import { render, staticRenderFns } from "./AccountInvoices.vue?vue&type=template&id=36602dee&"
import script from "./AccountInvoices.vue?vue&type=script&lang=js&"
export * from "./AccountInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports